import { UIRouter } from "@uirouter/angular";

export function otherwiseRule(path: string, router: UIRouter) {
  setTimeout(() => {
    router.globals.transition?.abort();
    if (/^\/airsem+/.test(path)) {
      router.stateService.go('emads');
      return;
    }
    router.stateService.go('error.404', { ...router.globals.params });
    return;
  });
}

export function emadsTrailingSlashConfigfn(router: UIRouter) {
  // This rule is to avoid the trailing slash in the url for emads
  // It's included in the root module because otherwise the transition is superseded
  const emadsTrailingSlashRegex = /^\/?emads(.*\/.*)*\/$/;
  router.urlService.rules.when(emadsTrailingSlashRegex, match => {
    console.log(match);
    return match[1] ? '/emads' + match[1] : '/emads';
  });
}
